module.exports = __webpack_public_path__ + "img/рз_18.190a50c8.png";